import { Center } from "@/shared/components/center/Center";
import { Splitter } from "@/shared/components/splitter/Splitter";
import { Stack } from "@/shared/components/stack/Stack";
import { LoginForm } from "../login-form/LoginForm";
import rectangleImg from "../../../shared/images/Rectangle.png";

export function Login() {
  return (
    <Splitter>
      <img
        src={rectangleImg}
        alt=""
        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
      />

      <Center>
        <Stack gap={"20px"}>
          <LoginForm />
        </Stack>
      </Center>
    </Splitter>
  );
}
